<template>
  <v-list-item :href="href" target="_blank" :class="backgroundColor">
    <div class="justify-center mr-4 d-flex align-center flag">
      <flag-pip :flag="item.language.flag" :text="item.language.name" :show-label="true" />
    </div>
    <v-list-item-content class="items-center mr-4 d-flex">
      <v-list-item-title>
        <v-chip v-if="hasCreatedPages" small :color="alreadyExists ? 'warning' : 'primary'" class="mr-2">
          {{ alreadyExists ? 'Already Existed!' : 'New!' }}
        </v-chip>
        <span>{{ title }}</span>
      </v-list-item-title>
      <v-list-item-subtitle v-text="subtitle" />
    </v-list-item-content>
    <v-list-item-action v-if="item.id">
      <copy-to-clipboard label="Page Link" :copy-value="href" />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import FlagPip from '@/views/news-articles/components/flag-pip'
import CopyToClipboard from '@/components/copy-to-clipboard'

export default {
  components: { FlagPip, CopyToClipboard },
  props: {
    item: {
      type: Object,
      required: true,
    },
    pageIds: {
      type: Array,
      required: true,
    },
  },
  computed: {
    hasCreatedPages() {
      return !!this.pageIds.length
    },
    alreadyExists() {
      const page = this.pageIds.find(({ id }) => id == this.item.id) || {}
      return page.exists || false
    },
    href() {
      if (!this.item.id) return null
      return `${window.location.origin}/content/pages/${this.item.id}`
    },
    title() {
      return this.item.entities.map(({ entity: { default: { name } } = {} }) => name).join('/')
    },
    subtitle() {
      return `${this.item.site.hostname} (${this.item.pageType.name})`
    },
    backgroundColor() {
      if (this.$vnode.key === 0 || this.$vnode.key % 2 === 0) return 'white'
      return 'grey lighten-3'
    },
  },
}
</script>

<style scoped>
.flag {
  width: 70px;
}
</style>
